// for add employee state
export const ADD_EMPLOYEE_SALARY_DATA = "add_employee_salary_data";
export const RESET_ADD_EMPLOYEE_SALARY_DATA = "reset_add_employee_salary_data";
